module.exports = __webpack_public_path__ + "img/medal01.6391e8f6.webp";